module.exports = __webpack_public_path__ + "img/user-icon-white.20201338.png";